import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';

// Auth & Security
import ProtectedRoute from './components/ProtectedRoute';

// Layouts
import MainLayout from './layouts/MainLayout';

// Pages
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import UserManagement from './pages/admin/UserManagement';
import Pairing from './pages/admin/Pairing';
import Commitments from './pages/mentee/Commitments';
import MentorMentees from './pages/mentor/MentorMentees';
import ProgressTracker from './pages/mentor/ProgressTracker';
import Forum from './pages/shared/Forum';
import HelpDesk from './pages/shared/HelpDesk';
import MentorDashboard from './pages/mentor/Dashboard';
import MenteeDashboard from './pages/mentee/Dashboard';
import HomeRedirect from './pages/shared/HomeRedirect';
import AdminDashboard from './pages/admin/Dashboard';
import AdminReports from './pages/admin/Reports';
import ResetPassword from './pages/auth/ResetPassword';
import ForgotPassword from './pages/auth/ForgotPassword';
import AboutElevateHer from './pages/shared/AboutElevateHer';
import MentorWelcome from './pages/shared/MentorWelcome';
import MenteeWelcome from './pages/shared/MenteeWelcome';


const Unauthorized = () => (
  <div style={{ textAlign: 'center', marginTop: '50px' }}>
    <h1>403 - Unauthorized</h1>
    <p>You do not have permission to view this page.</p>
  </div>
);

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#FE1F08', // Chalom Red
          colorInfo: '#FE1F08',
          borderRadius: 6,
          // Customizing Sidebar style through theme if needed
          colorBgContainer: '#ffffff',
        },
        components: {
          Layout: {
            colorBgHeader: '#ffffff',
            colorBgBody: '#f0f2f5',
          }
        }
      }}
    >
      <Router>
        <Routes>
          {/* --- Public Routes --- */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/about" element={<AboutElevateHer />} />

          {/* --- Protected Routes Wrapper --- */}
          <Route element={<ProtectedRoute />}>
            {/* All routes inside MainLayout will have the Sidebar and Header */}
            <Route element={<MainLayout />}>

              {/* Shared Routes */}
              <Route path="/profile" element={<div>User Profile Settings</div>} />
              <Route path="/help-desk" element={<HelpDesk />} />
              <Route path="/about-elevate-her" element={<AboutElevateHer />} />

              {/* --- Admin Only Access --- */}
              <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/admin/users" element={<UserManagement />} />
                <Route path="/admin/pairing" element={<Pairing />} />
                <Route path="/admin/reports" element={<AdminReports />} />
              </Route>

              {/* --- Mentor Only Access --- */}
              <Route element={<ProtectedRoute allowedRoles={['mentor']} />}>
                <Route path="/mentor/dashboard" element={<MentorDashboard />} />
                <Route path="/mentor/mentees" element={<MentorMentees />} />
                <Route path="/mentor/track/:matchId" element={<ProgressTracker />} />
                <Route path="/mentor/forum" element={<Forum type="Mentor" />} />
                <Route path="/mentor/welcome" element={<MentorWelcome />} />
              </Route>

              {/* --- Mentee Only Access --- */}
              <Route element={<ProtectedRoute allowedRoles={['mentee']} />}>
                <Route path="/mentee/dashboard" element={<MenteeDashboard />} />
                <Route path="/mentee/commitments" element={<Commitments />} />
                <Route path="/mentee/forum" element={<Forum type="Mentee" />} />
                <Route path="/mentee/welcome" element={<MenteeWelcome />} />
              </Route>

            </Route>
          </Route>

          {/* --- Global Redirects --- */}
          <Route path="/" element={<HomeRedirect />} />
          <Route path="*" element={<div style={{ padding: 20 }}>404 Not Found</div>} />
        </Routes>
      </Router>
    </ConfigProvider>
  );
}

export default App;